// Единый слой аналитики: вызывающий код не знает, куда уходят события.
// Приёмники — GA4 (gtag) и Яндекс.Метрика (ym); оба инициализируются в
// public/index.html, там же объявлены их очереди, поэтому вызовы отсюда
// безопасны даже до фактической загрузки тегов.
//
// В параметры событий не передаём PII: только id/slug материалов, названия
// дорам и имена фильтров. Логины, e-mail и токены сюда попадать не должны.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const YM_ID = process.env.REACT_APP_YM_COUNTER_ID;
const isProd = process.env.NODE_ENV === 'production';

// В dev только логируем — чтобы трафик разработки не попадал в продовую статистику
function debug(kind, name, params) {
  if (params === undefined) {
    console.debug(`[analytics] ${kind}: ${name}`);
  } else {
    console.debug(`[analytics] ${kind}: ${name}`, params);
  }
}

export function trackPageView(path, title) {
  if (!isProd) {
    debug('page_view', path, title);
    return;
  }
  if (GA_ID) {
    window.gtag?.('event', 'page_view', {
      page_path: path,
      page_title: title,
      page_location: window.location.href,
    });
  }
  if (YM_ID) {
    window.ym?.(YM_ID, 'hit', path, { title });
  }
}

export function trackEvent(name, params) {
  if (!isProd) {
    debug('event', name, params);
    return;
  }
  if (GA_ID) {
    window.gtag?.('event', name, params);
  }
  if (YM_ID) {
    // reachGoal ждёт имя цели; цель с таким идентификатором нужно один раз
    // создать в интерфейсе Метрики, иначе вызов просто игнорируется
    window.ym?.(YM_ID, 'reachGoal', name, params);
  }
}

export function setAnalyticsUser(userId) {
  if (!userId) return;
  if (!isProd) {
    debug('set user', userId);
    return;
  }
  if (GA_ID) {
    window.gtag?.('set', { user_id: String(userId) });
  }
  if (YM_ID) {
    window.ym?.(YM_ID, 'setUserID', String(userId));
  }
}
